import * as React from 'react'
import { ReactElement } from 'react'
import { Route, RouteComponentProps } from 'react-router'
import AddTime from './Time/AddTime'
import EditTime from './Time/EditTime'
import BaseTimeOverview from './Time/TimeOverview'
import GlobalTimeOverview from './Time/GlobalTimeOverview'
import EntityPage, { EntityPageProps, ParentProps } from './EntityPage'
import TimeSuggestionOverview from './Time/TimeSuggestionOverview'
import { BaseTimeOverviewProps } from './Time/BaseTimeOverview'

type Props = EntityPageProps & {
    fileId?: string
    overviewProps?: BaseTimeOverviewProps
}

export const timeBaseUrl = '/time'

export default function Times(props: Props): ReactElement {
    return (
        <EntityPage {...props} baseUrl={timeBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <>
                    <Route
                        exact
                        path={route}
                        render={(routeProps: RouteComponentProps) =>
                            props.fileId === undefined ? (
                                <GlobalTimeOverview baseUrl={baseUrl} />
                            ) : (
                                <BaseTimeOverview
                                    {...routeProps}
                                    {...props}
                                    baseUrl={baseUrl}
                                    localStorageKeyPrefix={`HammockTimeOverview-${props.fileId}-`}
                                />
                            )
                        }
                    />
                    <Route path={`${route}/suggestion`}>
                        <TimeSuggestionOverview />
                    </Route>
                    <Route path={`${route}/add`}>
                        <AddTime returnUrl={baseUrl} useFileContext={props.useFileContext} />
                    </Route>
                    <Route path={`${route}/:id/edit`}>
                        <EditTime returnUrl={baseUrl} useFileContext={props.useFileContext} />
                    </Route>
                </>
            )}
        </EntityPage>
    )
}
